




























































import { loginFromResponse } from '@antriver/vue-site-utils/src/util/auth';
import Vue from 'vue';
import { api, authTokenStore } from '@/services/api';
import ErrorMessageMixin from '@/mixins/ErrorMessageMixin';
import LoadingStateMixin from '@/mixins/LoadingStateMixin';
import SuccessStateMixin from '@/mixins/SuccessStateMixin';
import { showSuccessAlert } from '@/utils/alert';

export default Vue.extend({
    name: 'ResetPasswordView',

    mixins: [
        ErrorMessageMixin,
        LoadingStateMixin,
        SuccessStateMixin,
    ],

    data() {
        return {
            resetForm: {
                userId: null,
                resetToken: null,
                newPassword: '',
                confirmNewPassword: '',
            },
        };
    },

    created() {
        this.checkToken();
    },

    methods: {
        checkToken() {
            if (!this.$route.query.id || !this.$route.query.token) {
                this.setError('The link you clicked doesn\'t seem to be valid.');
                return;
            }

            // Send to the API to check this token is legit.
            this.setLoading(true);
            api
                .get(
                    `password-resets/${this.$route.query.token}`,
                    {
                        userId: this.$route.query.id,
                    },
                )
                .then((response) => {
                    this.resetForm.userId = response.user.id;
                    this.resetForm.resetToken = response.resetToken;
                })
                .catch(() => {
                    this.setError('The link you clicked doesn\'t seem to be valid.');
                })
                .finally(() => {
                    this.setLoading(false);
                });
        },

        submit() {
            if (this.loading) {
                return;
            }
            this.setSuccess(false);

            if (this.resetForm.confirmNewPassword !== this.resetForm.newPassword) {
                this.setError('The new password and confirmation you entered do not match.');
                return;
            }

            this.setLoading(true);
            this.clearError();
            api
                .patch(
                    `users/${this.resetForm.userId}/password`,
                    {
                        password: this.resetForm.newPassword,
                        resetToken: this.resetForm.resetToken,
                        extraAuthInfo: 1,
                    },
                )
                .then((response) => {
                    if (response.success) {
                        showSuccessAlert('You password has been successfully changed. You are now being logged in.');
                    }
                    this.setSuccess(response.success);
                    if (response.token) {
                        loginFromResponse(
                            authTokenStore,
                            this.$store,
                            response,
                            this.$router,
                            true,
                        );
                    }
                })
                .catch(({ message }) => {
                    this.setError(message);
                })
                .finally(() => {
                    this.setLoading(false);
                });
        },
    },

});

